export type PaginationResponse<T> = {
  count: number;
  next: string;
  previous: string;
  results: T[];
};

export const UnlimitedList = -1;
export const EventsLimitedList = 100;
